import AddIcon from '@mui/icons-material/Add';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import { Button } from "@mui/material";
import { default as React } from "react";
import { CircleLoader } from "react-spinners";

const CustomButton = ({
  text,
  type = "button",
  width = "120px",
  height = "40px",
  backgroundColor = type === "submit"
    ? "#ceebee"
    : type === "cancel"
    ? "#fbdede"
    : type === "addNew"
    ? "#2c90f7"
    : type === "download"
    ? "#2e7d33"
    : "#fbdede",
  color = type === "submit"
    ? "#13a7b9"
    : type === "cancel"
    ? "#eb5757"
    : type === "addNew" || type === "download"
    ? "#ffffff"
    : "#eb5757",
  fontSize = "16px",
  startIcon,
  endIcon,
  onClick,
  loading = false,
  loadingSize = 20,
  loaderStyle = {},
  children,
  tabIndex = 0,
}) => {

  const getStartIcon = () => {
    if (startIcon) return startIcon;
    if (type === "submit") return <CheckIcon />;
    if (type === "cancel") return <CloseIcon />;
    if (type === "addNew") return <AddIcon />;
    if (type === "download") return <FileDownloadIcon />;
    return null;
  };

  return (
    <Button
      variant="contained"
      type={type}
      tabIndex={tabIndex}
      sx={{
        width,
        height,
        backgroundColor,
        color,
        fontSize,
        textTransform: "none",
        "&:hover": {
          backgroundColor:
            type === "submit"
              ? "#13a7b9"
              : type === "cancel"
              ? "#eb5757"
              : type === "addNew"
              ? "#1a7de0"
              : type === "download"
              ? "#236e29"
              : "#eb5757",
          color: "#fff",
        },
      }}
      startIcon={getStartIcon()}
      endIcon={endIcon}
      onClick={onClick}
    >
      {loading ? (
        <CircleLoader
          size={loadingSize}
          sx={{ ...loaderStyle }}
          color="white"
        />
      ) : (
        children || text
      )}
    </Button>
  );
};

export default CustomButton;